import { merge } from "lodash";
import { serialize } from "object-to-formdata";
import { generateEndpoints, prefix } from "../helpers";
/**
 * This is the reource identifier
 * Everything will be under users.get, users.getAll, users.create, users.createAndSendEmail etc...
 */
const namespace = "profile";

const nameSpace = merge({}, generateEndpoints(namespace), {
  get: {
    // getDownloadUrl: id => [`${prefix}/mango/repository-objects/${id}/download`],
    getUserDocuments: ({ entityType, entityId }) => {
      return [`${prefix}/${namespace}/${entityType}/${entityId}/attachment`];
     },
    getDetail: ({ entityType, entityId, id }) => {
    return [`${prefix}/${namespace}/${entityType}/${entityId}/attachment/${id}`];
  }
},

  post: {
    createObjectInstance: ({ entityType, entityId, data }) => {
      return [`${prefix}/${namespace}/${entityType}/${entityId}/attachment`, data];
    },
  },
  put: {
    upload: ({ url, file }) => {
      return [url, file];
    },
    checkUpload: (url) => [url],
    update: ({ entityType, entityId, data }) => {
      return [`${prefix}/${namespace}/${entityType}/${entityId}/attachment/status`, data];
    },
  },
  delete: {
    delete: ({ id, entityType, entityId }) => {
      return [`${prefix}/${namespace}/${entityType}/${entityId}/attachment/${id}`];
    },
  }    
});

export default nameSpace;
